(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-split-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pf-split-slider')) {
  customElements.define('pf-split-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editor = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.live = this.querySelector('[data-slides]');
      this.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, {signal});
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, {signal});
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, {signal});
      this.addEventListener('focusout', () => { this.focused = false; this.schedule(); }, {signal});
      this.live.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'touch' || !e.isPrimary) return;
        this.start = {x:e.clientX,y:e.clientY};
      }, {signal});
      this.live.addEventListener('pointerup', e => {
        if (!this.start) return;
        const dx=e.clientX-this.start.x,dy=e.clientY-this.start.y;
        this.start=null;
        if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.5) {
          this.suppressClick=true;
          clearTimeout(this.clickTimer);
          this.clickTimer=setTimeout(()=>this.suppressClick=false,400);
          this.show(this.index+(dx<0?1:-1));
        }
      }, {signal});
      this.live.addEventListener('pointercancel',()=>this.start=null,{signal});
      this.live.addEventListener('click',e=>{
        if(this.suppressClick){e.preventDefault();e.stopPropagation();this.suppressClick=false;}
      },{capture:true,signal});
      document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
      this.reduced.addEventListener('change',()=>this.schedule(),{signal});
      this.addEventListener('shopify:block:select',e=>{
        const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);
        if(i>=0){this.editor=true;this.show(i);}
      },{signal});
      this.addEventListener('shopify:block:deselect',()=>{this.editor=false;this.schedule();},{signal});
      this.querySelectorAll('[data-pf-direction]').forEach(button => {
        button.addEventListener('click', () => this.show(this.index + Number(button.dataset.pfDirection)), {signal});
      });
      this.mediaObserver = new ResizeObserver(() => this.updateArrowHeight());
      this.slides.forEach(slide => {
        const media = slide.querySelector('.pf-split__media');
        if (media) this.mediaObserver.observe(media);
      });
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{
        slide.hidden=i!==this.index;
        slide.inert=i!==this.index;
      });
      this.updateArrowHeight();
      this.schedule();
    }
    updateArrowHeight() {
      const media = this.slides[this.index]?.querySelector('.pf-split__media');
      if (media) this.style.setProperty('--pf-mobile-media-height', media.getBoundingClientRect().height + 'px');
    }
    schedule() {
      clearTimeout(this.timer);
      const running=this.slides.length>1&&!this.reduced.matches&&!this.hovered&&!this.focused&&!this.editor&&!document.hidden;
      if(this.live)this.live.setAttribute('aria-live',running?'off':'polite');
      if(running)this.timer=setTimeout(()=>this.show(this.index+1),6000);
    }
    disconnectedCallback(){
      clearTimeout(this.timer);clearTimeout(this.clickTimer);
      this.mediaObserver?.disconnect();
      this.controller?.abort();this.controller=null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
